import api from '../../api/axios';

export const getSentences = async (payload) => {
  try {
    const { data } = await api.post(`/api/sentences/search`, payload);
    return { isError: false, data };
  } catch (error) {
    throw { isError: true, error };
  }
};

export const getSelectedData = async (set, patientID, setId) => {
  try {
    const { data } = await api.get(
      `/api/patients/${patientID}/${set}/${setId}`,
    );
    return { isError: false, data };
  } catch (error) {
    throw { isError: true, error };
  }
};
